import { FC, useState } from 'react';

import { ContentCopy } from '@mui/icons-material';
import { Box, Tooltip, Typography, SxProps } from '@mui/material';

import { copyTextToClipboard } from '../../utils/copyToClipboard';
import {abbreviateId} from "../../utils/humanizer";

interface TooltipCopyProps {
  value?: string;
  hiddeTooltip?: boolean;
  sx?: SxProps;
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top';
}

export const TooltipCopy: FC<TooltipCopyProps> = ({ value, children, placement = 'top', hiddeTooltip, sx }) => {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <Tooltip
      open={showTooltip}
      onOpen={() => setShowTooltip(true)}
      onClose={() => setShowTooltip(false)}
      title={
        hiddeTooltip ? (
          ''
        ) : (
          <Box onClick={() => copyTextToClipboard(value)}>
            <Typography
              variant="body2"
              fontWeight={600}
              sx={{
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              <ContentCopy fontSize={'small'} sx={{ mr: 1 }} />
                {abbreviateId(value)}
            </Typography>
          </Box>
        )
      }
      placement={placement}
    >
      <Box sx={{ ...sx }} onClick={() => setShowTooltip(!showTooltip)}>
        {children}
      </Box>
    </Tooltip>
  );
};
